import {defineStore} from 'pinia';
import {ModuleSalaryScale} from '../moduleConst';
import {BaseDictionaryStore} from '../baseDictionaryStore';
import ColumnCommon from '@/commons/wildcards/constants/ColumnCommon';
import salaryScaleAPI from '@/apis/di/salaryScaleAPI';

const salaryScaleStore = new BaseDictionaryStore(salaryScaleAPI);
export const useSalaryScaleStore = defineStore(ModuleSalaryScale, {
  state: () => ({
    ...salaryScaleStore.state,
    _config: {
      key: 'salary_scale_id',
      code: 'salary_scale_code',
      table: 'di_salary_scale',
      moduleName: 'Ngạch lương',
      quickFollow: 'active',
      defaultSort: 'salary_scale_code',
    },
    moduleName: 'salaryScale',
  }),
  actions: {...salaryScaleStore.action},
});
